import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Importer le fichier CSS pour les animations

export const Features = (props) => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialiser AOS avec une durée d'animation de 1 seconde
  }, []);

  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Avantages</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="col-xs-6 col-md-3"
                  data-aos="fade-up" // Définir l'animation AOS
                >
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
